/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_CityInputs */

const en_admin_external_booking_edit_city = /** @type {(inputs: Admin_External_Booking_Edit_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City`)
};

const de_admin_external_booking_edit_city = /** @type {(inputs: Admin_External_Booking_Edit_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stadt`)
};

const es_admin_external_booking_edit_city = /** @type {(inputs: Admin_External_Booking_Edit_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciudad`)
};

const fr_admin_external_booking_edit_city = /** @type {(inputs: Admin_External_Booking_Edit_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ville`)
};

/** @type {(inputs: Admin_External_Booking_Edit_CityInputs) => LocalizedString} */
const it_admin_external_booking_edit_city = en_admin_external_booking_edit_city;

/** @type {(inputs: Admin_External_Booking_Edit_CityInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_city = en_admin_external_booking_edit_city;

/** @type {(inputs: Admin_External_Booking_Edit_CityInputs) => LocalizedString} */
const pl_admin_external_booking_edit_city = en_admin_external_booking_edit_city;

/** @type {(inputs: Admin_External_Booking_Edit_CityInputs) => LocalizedString} */
const hu_admin_external_booking_edit_city = en_admin_external_booking_edit_city;

/** @type {(inputs: Admin_External_Booking_Edit_CityInputs) => LocalizedString} */
const ro_admin_external_booking_edit_city = en_admin_external_booking_edit_city;

/**
* | output |
* | --- |
* | "City" |
*
* @param {Admin_External_Booking_Edit_CityInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_city = /** @type {((inputs?: Admin_External_Booking_Edit_CityInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_CityInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_city(inputs)
	if (locale === "de") return de_admin_external_booking_edit_city(inputs)
	if (locale === "es") return es_admin_external_booking_edit_city(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_city(inputs)
	if (locale === "it") return it_admin_external_booking_edit_city(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_city(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_city(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_city(inputs)
	return ro_admin_external_booking_edit_city(inputs)
});
export { admin_external_booking_edit_city as "admin.external_booking_edit.city" }